<template>
  <div>
    <div class="asc-descriptions-item">
      <asc-parameter-alert-item
        :status="status"
        simple
      ></asc-parameter-alert-item>
      <span class="asc-descriptions-item--label">; Value: {{ value }}</span>
    </div>
  </div>
</template>

<script>
import { AscStatusPropsMixin } from '@/components/mixins'
import AscParameterAlertItem from './AscParameterAlertItem'

export default {
  name: 'AscAlertDescriptionsItem',

  components: {
    AscParameterAlertItem,
  },

  mixins: [AscStatusPropsMixin],

  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-descriptions-item {
  display: flex;
  width: 100%;
}
</style>
